import { t } from "@/i18n-js/instance";
import checkImgPath from "./img/attending.svg";

export const CheckIcon = () => (
  <img loading="lazy" src={checkImgPath} alt={t("events.rsvp.attending")} />
);
